import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

const DataHandler = {
  checkKey(key, APIFunction, override = false) {
    return StorageHandler.load(storageKeys[key.name || key]).then(
      (localKey) => {
        if (
          localKey !== false &&
          !StorageHandler.isExpired(key.name || key) &&
          override !== true
        ) {
          return StorageHandler.load(storageKeys[key.name || key]).then(
            (result) => result
          );
        } else if (storageKeys[key.name || key]) {
          // if key is defined, try to get it from the API
          console.warn(
            `key ${key.name || key} expired: ${StorageHandler.isExpired(
              key.name || key
            )}`
          );
          return APIFunction.then((apiResponse) => {
            if (
              Object.keys(apiResponse).length > 0 &&
              apiResponse.status !== 'error'
            ) {
              StorageHandler.save(storageKeys[key.name || key], apiResponse);
            }
            return apiResponse;
          });
        }
        return false;
      }
    );
  },

  matchAppId() {
    const appId = import.meta.env.VITE_APP_ID;
    return StorageHandler.load(storageKeys.appId).then((id) => {
      if (id !== appId) {
        StorageHandler.save(storageKeys.appId, appId);
      }
      return appId;
    });
  },

  requestWithId(requestFunction, optionalParams) {
    return DataHandler.matchAppId().then((appId) =>
      requestFunction(appId, optionalParams).then((response) => response)
    );
  },
};

export default DataHandler;
